<div class="row align-items-center mb-2">
  <div [ngClass]="this.colClass()">
    <span>{{ label() }}</span>
    <ng-content></ng-content>
  </div>

  <div class="col-auto d-flex align-items-center gap-3">
    <p-selectbutton
      [options]="booleanOptions"
      [ngModel]="this.value"
      (ngModelChange)="onValueChange($event)"
      optionLabel="label"
      optionValue="value"
      [unselectable]="true"
      [disabled]="this.isDisabled() ?? false"
    ></p-selectbutton>
    <ng-content select="[afterToggle]"></ng-content>
  </div>
</div>